import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api from "../api"
import { DispatchModel } from "../api/dispatch.api"

export interface DispatchsListState {
    dispatchs: DispatchModel[]
    loading: boolean
    error?: string
    shippingcompany: []
}

const initialState: DispatchsListState = {
    dispatchs: [],
    loading: false,
    shippingcompany: []
}

export interface DispatchsPrintState {
    parcels: []
}

export interface paginationData {
    company?: string
    warehouse?: string
}

export const loadDispatchs = createAsyncThunk("dispatchs/list", async (data: paginationData, thunkAPI) => {
    try {
        const response = await api.dispatch.dispatchsList(data)
        if (response.status) {
            return response
        }
    } catch (error: any) {
        console.log(error)
    }
})

export const loadShippingCompany = createAsyncThunk("shipping/list", async (warehouse: string, thunkAPI) => {
    try {
        const response = await api.dispatch.shippingCompanyList(warehouse)

        if (response.status) {
            return response
        }
    } catch (error: any) {
        console.log(error)
    }
})

export const printMenifest = createAsyncThunk(
    "parcels/edit",
    async (printParcelData: DispatchsPrintState, thunkAPI) => {
        try {
            const response = await api.dispatch.printMenifest(printParcelData)
            if (response.status) {
                return response
            }
        } catch (error: any) {
            console.log(error)
        }
    }
)

export const dispatchsSlice = createSlice({
    name: "dispatchs",
    initialState,

    reducers: {
        clearError: (state: DispatchsListState) => {
            state.error = undefined
        }
    },

    extraReducers: {
        [loadDispatchs.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadDispatchs.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.data?.data?.error || ""
        },
        [loadDispatchs.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.dispatchs = action.payload?.data?.payload || []
        },
        [loadShippingCompany.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadShippingCompany.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.response?.data?.error || ""
        },
        [loadShippingCompany.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.shippingcompany = action.payload?.data?.payload || []
        },
        [printMenifest.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [printMenifest.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.response?.data?.error || ""
        },
        [printMenifest.fulfilled.toString()]: (state, action) => {
            state.loading = false
        }
    }
})

export const { clearError } = dispatchsSlice.actions

export default dispatchsSlice.reducer
